

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), [h('path', {"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14 26c6.627 0 12-5.373 12-12S20.627 2 14 2 2 7.373 2 14s5.373 12 12 12ZM11.052 9.445l2.462 2.134a.742.742 0 0 0 .972 0l2.462-2.134a1.14 1.14 0 0 1 1.607 1.607l-2.134 2.462a.742.742 0 0 0 0 .972l2.134 2.462a1.14 1.14 0 0 1-1.607 1.607l-2.462-2.134a.742.742 0 0 0-.972 0l-2.462 2.134a1.14 1.14 0 0 1-1.607-1.607l2.134-2.462a.742.742 0 0 0 0-.972l-2.134-2.462a1.14 1.14 0 0 1 1.607-1.607Z","fill":"currentColor"}, [])]);
};

        